import * as fromConfig from '../actions/config.action';

export interface ConfigState {
  shiftTypes: any;
  error: any;
}

export const initialState = {
  shiftTypes: [],
  error: null,
};

export function reducer(state = initialState, action: fromConfig.ConfigAction): ConfigState {
  switch (action.type) {
    case fromConfig.GET_CONFIG: {
      return {
        ...state
      };
    }
    case fromConfig.GET_CONFIG_SUCCESS: {
      const {shiftTypes} = action.payload;
      return {
        ...state,
        shiftTypes: shiftTypes,
      };
    }
    case fromConfig.GET_CONFIG_FAIL: {
      return {
        ...state,
        error: action.payload
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/reducers/config.reducer.ts